export class TimeoutError extends Error {
  constructor(public readonly originalError?: any) {
    super('Timeout exception');
  }
}
